// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_IndexResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for index() — GET /caixa
 */
import type { Caixa_IndexItemRow } from './Caixa_IndexItemRow'
import type { Caixa_PaginationRow } from './Caixa_PaginationRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Caixa_IndexResponseDados {
items: Caixa_IndexItemRow[]
pagination: Caixa_PaginationRow
}

export type Caixa_IndexResponse = ApiResponse<Caixa_IndexResponseDados>;

registerResponseContract('Caixa_IndexResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      id:                    { type: 'number',  required: false },
      franquia_id:           { type: 'number',  required: false },
      operador_id:           { type: 'number',  required: false },
      data_hora_abertura:    { type: 'string',  required: false },
      data_hora_fechamento:  { type: 'string',  required: false },
      saldo_inicial:         { type: 'string',  required: false },
      saldo_final_esperado:  { type: 'string',  required: false },
      diferenca:             { type: 'string',  required: false },
      status:                { type: 'string',  required: false },
      created_at:            { type: 'string',  required: false },
      updated_at:            { type: 'string',  required: false },
      deleted_at:            { type: 'string',  required: false },
      saldo_final_declarado: { type: 'string',  required: false },
      observacao:            { type: 'string',  required: false },
    },
  },
  pagination: {
    type: 'object',
    required: true,
    fields: {
      page:        { type: 'number',  required: false },
      per_page:    { type: 'number',  required: false },
      total:       { type: 'number',  required: false },
      total_pages: { type: 'number',  required: false },
    },
  },
})
